/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tm_Page_TitleInputs */

const en_tm_page_title = /** @type {(inputs: Tm_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team & settings`)
};

const id_tm_page_title = /** @type {(inputs: Tm_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tim & pengaturan`)
};

/**
* | output |
* | --- |
* | "Team & settings" |
*
* @param {Tm_Page_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tm_page_title = /** @type {((inputs?: Tm_Page_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tm_Page_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tm_page_title(inputs)
	return en_tm_page_title(inputs)
});